
import { schema, schemaOld } from "./types";
import { OverviewPanel,OperatorPanel } from '.';
import { RiBuildingLine } from "react-icons/ri";
import { IAutomationAppComponent } from "../../../types";

export const AppOld : IAutomationAppComponent = {
    schema: schemaOld,
    supportsProcessPanel: false,
    Icon: RiBuildingLine,
    OverviewPanel: OverviewPanel,
    OperatorPanel: OperatorPanel,
}

export const App : IAutomationAppComponent = {
    schema: schema,
    supportsProcessPanel: false,
    Icon: RiBuildingLine,
    OverviewPanel: OverviewPanel,
    OperatorPanel: OperatorPanel,
    createConfig:  {
        group: 'ReportsAndStatistics',
        name: "Compare the energy of all your buildings",
        description: "Buidlings energy compare",
        panel: OverviewPanel,
        defaultState: {  },
        defaultProperties: [ ]
    },
}